import { ValueOf } from "../type";

export const ServiceInspectKey = {
  DocsPdfInspect: "DOCS_PDF_INSPECT",
  DocsInspect: "DOCS_INSPECT",
  PapyrusInspect: "PAPYRUS_INSPECT",
} as const;

export type DocsPdfServiceInspectKeyType = ValueOf<typeof ServiceInspectKey>;
